import { TaggedError } from "@for-it/domain-lib";
export class SubdomainAlreadyExistsError extends TaggedError {
    subdomain;
    constructor(subdomain) {
        super("SubdomainAlreadyExistsError");
        this.subdomain = subdomain;
    }
}
